import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder_key';

// Create a generic, unauthenticated Supabase client (used for public tasks if any)
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper function to create an authenticated Supabase client using Clerk's JWT
export const createClerkSupabaseClient = (clerkToken: string) => {
  return createClient(supabaseUrl, supabaseAnonKey, {
    global: {
      headers: {
        Authorization: `Bearer ${clerkToken}`,
      },
    },
  });
};

// Deterministic hash to convert Clerk User ID string to a valid UUID format
export const clerkIdToUuid = (clerkId: string): string => {
  if (!clerkId) return '00000000-0000-0000-0000-000000000000';
  
  let h1 = 0x811c9dc5;
  let h2 = 0xcbf29ce4;
  let h3 = 0x58271510;
  let h4 = 0x141c6ce5;

  for (let i = 0; i < clerkId.length; i++) {
    const char = clerkId.charCodeAt(i);
    h1 = Math.imul(h1 ^ char, 16777619);
    h2 = Math.imul(h2 ^ char, 16777619);
    h3 = Math.imul(h3 ^ char, 16777619);
    h4 = Math.imul(h4 ^ char, 16777619);
  }

  const hex = (val: number) => {
    return (val >>> 0).toString(16).padStart(8, '0');
  };

  const s1 = hex(h1);
  const s2 = hex(h2);
  const s3 = hex(h3);
  const s4 = hex(h4);

  const part1 = s1;
  const part2 = s2.substring(0, 4);
  const part3 = '4' + s2.substring(5, 8); 
  const part4 = ((parseInt(s3.substring(0, 2), 16) & 0x3f) | 0x80).toString(16).padStart(2, '0') + s3.substring(2, 4); 
  const part5 = s3.substring(4, 8) + s4;

  return `${part1}-${part2}-${part3}-${part4}-${part5}`;
};
